export enum CONSTANTS {
  CATEGORYCTRL = "categeyControls",
  GENERATEDTONS = "totalGeneratedTons",
  CREATE = "create",
  QUESTIONLIST = "questionList",
  DELETE = "delete",
}
